import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=0fdd87b8&"
import script from "./forgot-password.vue?vue&type=script&lang=js&"
export * from "./forgot-password.vue?vue&type=script&lang=js&"
import style0 from "./forgot-password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fdd87b8')) {
      api.createRecord('0fdd87b8', component.options)
    } else {
      api.reload('0fdd87b8', component.options)
    }
    module.hot.accept("./forgot-password.vue?vue&type=template&id=0fdd87b8&", function () {
      api.rerender('0fdd87b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/forgot-password.vue"
export default component.exports